module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/dutch-ef20a3444906b594.png"+" 48w",
        images: [{path: __webpack_public_path__ + "assets/images/dutch-ef20a3444906b594.png",width: 48,height: 48}],
        src: __webpack_public_path__ + "assets/images/dutch-ef20a3444906b594.png",
        toString: function(){return __webpack_public_path__ + "assets/images/dutch-ef20a3444906b594.png"},
        
        width: 48,
        height: 48
      }